'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "align", "classPrefix", "color", "className", "maxLines", "weight", "muted", "transform", "size", "style"];
import React from 'react';
import PropTypes from 'prop-types';
import { useClassNames } from "../internals/hooks/index.js";
import { oneOf } from "../internals/propTypes/index.js";
var fontSizeMap = {
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
  xxl: 20
};
/**
 *
 * The `Text` component is used to display text.
 *
 * @see https://rsuitejs.com/components/text
 */
var Text = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'p' : _props$as,
    align = props.align,
    _props$classPrefix = props.classPrefix,
    classPrefix = _props$classPrefix === void 0 ? 'text' : _props$classPrefix,
    color = props.color,
    className = props.className,
    maxLines = props.maxLines,
    weight = props.weight,
    muted = props.muted,
    transform = props.transform,
    size = props.size,
    style = props.style,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useClassNames = useClassNames(classPrefix),
    withClassPrefix = _useClassNames.withClassPrefix,
    merge = _useClassNames.merge;
  var classes = merge(className, withClassPrefix(color, align, weight, transform, {
    muted: muted,
    ellipsis: maxLines
  }));
  var styles = _extends({
    fontSize: fontSizeMap[size] || size
  }, maxLines ? {
    WebkitLineClamp: maxLines
  } : null, style);
  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
    ref: ref,
    className: classes,
    style: styles
  }));
});
Text.displayName = 'Text';
Text.propTypes = {
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  as: PropTypes.elementType,
  size: PropTypes.oneOfType([PropTypes.number, oneOf(['sm', 'md', 'lg', 'xl', 'xxl'])]),
  muted: PropTypes.bool,
  transform: oneOf(['uppercase', 'lowercase', 'capitalize']),
  align: oneOf(['left', 'center', 'right', 'justify']),
  weight: oneOf(['thin', 'light', 'regular', 'medium', 'semibold', 'bold', 'extrabold']),
  maxLines: PropTypes.number
};
export default Text;